<template>
  <form class="search-holder">
    <div class="search-col">
      <label class="form-group">
        <div class="label">Property</div>
        <multiselect
          ref="searchItem"
          v-model="selectedItemModel"
          class="select-search-item is-small"
          track-by="id"
          label="label"
          :options="searchOptions"
          :internal-search="false"
          :clear-on-select="false"
          :preserve-search="true"
          :allow-empty="false"
          :show-labels="false"
          placeholder="Search..."
          @search-change="onSearch"
          @input="onItemChange"
        >
          <template slot="clear">
            <div
              v-if="selectedItem"
              class="multiselect__clear"
              @mousedown.prevent.stop="clear"
            />
          </template>
          <span slot="noResult">No cities or hotels found. Consider changing the search query.</span>
          <span slot="noOptions">Start typing to search for cities or hotels...</span>
          <template
            slot="option"
            slot-scope="{ option }"
          >
            <div
              class="select-search-item__option"
              :class="{
                [`type-${option.type}`]: true,
              }"
            >
              <span class="select-search-item__option-icon">
                <img
                  v-if="option.type === 'city'"
                  :src="require('@/assets/icons/icon-location.svg')"
                  alt=""
                  width="10"
                  height="15"
                >
                <img
                  v-if="option.type === 'hotel'"
                  :src="require('@/assets/icons/icon-hotel.svg')"
                  alt=""
                  width="15"
                  height="10"
                >
              </span>
              <span class="select-search-item__option-title">
                {{ option.label }}
              </span>
            </div>
          </template>
        </multiselect>
        <!-- <input
          :value="title"
          type="text"
        > -->
      </label>
    </div>
    <div class="search-col">
      <div class="form-group">
        <custom-date-picker
          v-model="chakInDate"
          placeholder="Select date"
          class="date-picker"
        >
          <div slot="label">
            Check In
          </div>
        </custom-date-picker>
      </div>
      <div class="form-group">
        <custom-date-picker
          v-model="chakOutDate"
          placeholder="Select date"
          class="date-picker"
        >
          <div slot="label">
            Check Out
          </div>
        </custom-date-picker>
      </div>
    </div>
    <div class="search-col">
      <div class="form-group">
        <div class="label">
          Rooms
        </div>
        <multiselect
          v-model="roomsModel"
          class="select-transparent is-slim"
          track-by="id"
          label="label"
          :options="[
            {
              id: 1,
              label: '1 Room',
            },
            {
              id: 2,
              label: '2 Rooms',
            },
            {
              id: 3,
              label: '3 Rooms',
            },
            {
              id: 4,
              label: '4 Rooms',
            },
          ]"
          :searchable="false"
          :allow-empty="false"
          :show-labels="false"
        />
      </div>
      <div class="form-group">
        <div class="label">
          Passengers
        </div>
        <multiselect
          v-model="passengersModel"
          class="select-transparent is-slim"
          track-by="id"
          label="label"
          :options="[
            {
              id: 1,
              label: '1 Adult',
            },
            {
              id: 2,
              label: '2 Adults',
            },
            {
              id: 3,
              label: '3 Adults',
            },
            {
              id: 4,
              label: '4 Adults',
            },
          ]"
          :searchable="false"
          :allow-empty="false"
          :show-labels="false"
        />
      </div>
    </div>
    <div class="search-col ml-auto">
      <button
        class="btn"
        @click.prevent="submit"
      >
        Search
      </button>
    </div>
  </form>
</template>

<script>
import { mapActions } from 'vuex';
import CustomDatePicker from './tiny/CustomDatePicker';

export default {
  name: 'abs-room-card',
  components: {
    CustomDatePicker,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      cities: null,
      hotels: null,
      selectedItem: null,

      hotelName: 'MGM Grand Hotel & Casino, Las Vegas',
      chakInDate: new Date('Thu Feb 13 2020 00:00:00 GMT+0200 (Eastern European Standard Time)'),
      chakOutDate: new Date('Thu Feb 20 2020 00:00:00 GMT+0200 (Eastern European Standard Time)'),
      roomsModel: {
        id: 1,
        label: '1 Room',
      },
      passengersModel: {
        id: 1,
        label: '1 Adult',
      },
    };
  },
  computed: {
    searchOptions() {
      if (!this.cities && !this.hotels) {
        return [];
      }
      const cities = this.cities ? this.cities.map(city => ({
        id: city.toLowerCase(),
        label: city,
        type: 'city',
      })) : [];
      const hotels = this.hotels ? this.hotels.map(({ displayName, hotelId }) => ({
        id: hotelId,
        label: displayName,
        type: 'hotel',
      })) : [];
      return [
        ...cities,
        ...hotels,
      ];
    },
    selectedItemModel: {
      get() {
        if (!this.selectedItem) return null;
        return this.searchOptions.find(({ id }) => id === this.selectedItem) || null;
      },
      set({ id }) {
        this.selectedItem = id;
      },
    },
  },
  methods: {
    ...mapActions([
      'getCities',
      'getHotelsShort',
    ]),
    submit() {
      if (!this.selectedItemModel) {
        this.$router.push({
          name: 'search-results',
        });
      } else if (this.selectedItemModel.type === 'city') {
        this.$router.push({
          name: 'search-results',
          query: {
            city: this.selectedItemModel.label.toLowerCase(),
            type: 'property',
          },
        });
      } else if (this.selectedItemModel.type === 'hotel') {
        this.$router.push({
          name: 'content',
          params: {
            id: this.selectedItemModel.id,
          },
        });
      } else {
        this.$router.push({
          name: 'search-results',
        });
      }
    },
    onItemChange(val) {
      this.$refs.searchItem.search = val.label;
    },
    async onSearch(query) {
      const [
        cities,
        hotels,
      ] = await Promise.all([
        this.getCities(),
        this.getHotelsShort(),
      ]);
      this.cities = cities.filter(city => city.toLowerCase().indexOf(query.toLowerCase()) > -1);
      this.hotels = hotels.filter(({ displayName }) => displayName.toLowerCase().indexOf(query.toLowerCase()) > -1);
    },
    clear() {
      this.selectedItem = null;
      this.$refs.searchItem.search = '';
    },
  },
};
</script>

<style scoped lang="scss">
.search {

  &-holder {
    display: flex;
    padding: 14px 24px;
    background-color: #f7f9fc;

    @media (min-width: 1024px) {
      padding: 16px 50px;
    }
  }

  &-col {
    padding: 8px 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding-right: 12px;

    @media (min-width: 1024px) {
      padding-right: 32px;
    }

    &:not(:first-child) {
      border-left: 1px solid rgba(#6e7c91, .07);
      padding-left: 12px;

      @media (min-width: 1024px) {
        padding-left: 32px;
      }
    }

    &:last-child {
      padding-right: 0;
      border-left: none;
    }

    &.grow {
      flex-grow: 1;
    }
  }
}

.form-group {
  display: block;

  &:not(:last-child) {
    margin-bottom: 16px;
  }

  .label {
    color: #6e7c91;
    font-size: 9px;
    text-transform: uppercase;
  }

  .select-transparent {
    display: block;
    width: 100%;
    min-width: 120px;
  }
  select {
    display: block;
    width: 100%;
    color: #6e7c91;
    font-size: 15px;
    line-height: 21px;
    font-weight: 700;
    border: none;
    background: none;
    font-family: inherit;
  }

  select {
    min-width: 110px;
    -webkit-appearance: none;
    -moz-appearance: none;
    background-image: url('../assets/icons/arrow-down.png');
    background-repeat: no-repeat;
    background-size: 10px auto;
    background-position: 95% center;

    &::-ms-expand {
      display: none;
    }
  }
}

.ml-auto {
  margin-left: auto;
}

.select-search-item {
  width: 280px;
}
</style>
